// src/utils/bibleReferenceSuggestions.js
// Returns an array of suggestions for Bible references as the user types
// e.g., input: 'jo' => ['John 1:1', 'John 3:16', ...]


import { BIBLE_BOOKS } from '../App';

export function getBibleReferenceSuggestions(input) {
  if (!input) return [];
  const lower = input.toLowerCase();
  let suggestions = [];
  for (const book of BIBLE_BOOKS) {
    if (book.name.toLowerCase().startsWith(lower) || (lower.length > 2 && book.name.toLowerCase().includes(lower))) {
      // Suggest book only
      suggestions.push(book.name);
      // Suggest book + chapter (for all chapters in the book)
      for (let c = 1; c <= book.chapters; c++) {
        suggestions.push(`${book.name} ${c}`);
        // If input matches book+chapter, suggest first 5 verses for that chapter
        if (
          lower === `${book.name.toLowerCase()} ${c}` ||
          lower.startsWith(`${book.name.toLowerCase()} ${c}`)
        ) {
          for (let v = 1; v <= 5; v++) {
            suggestions.push(`${book.name} ${c}:${v}`);
          }
        }
      }
    }
  }
  // If input matches a book + chapter, suggest all verses in that chapter
  const bookMatch = BIBLE_BOOKS.find(b => lower.startsWith(b.name.toLowerCase()));
  if (bookMatch) {
    const rest = input.slice(bookMatch.name.length).trim();
    const chapMatch = rest.match(/^(\d+)$/);
    if (chapMatch) {
      const chapter = parseInt(chapMatch[1], 10);
      if (chapter > 0 && chapter <= bookMatch.chapters) {
        for (let v = 1; v <= 5; v++) {
          suggestions.push(`${bookMatch.name} ${chapter}:${v}`);
        }
      }
    }
  }
  // Remove duplicates and filter out impossible references
  return [...new Set(suggestions)].filter(s => {
    // Only allow valid book, book+chapter, or book+chapter:verse
    const m = s.match(/^(.*?)\s*(\d+)?(?::(\d+))?$/);
    if (!m) return false;
    const book = BIBLE_BOOKS.find(b => b.name === m[1]);
    if (!book) return false;
    if (!m[2]) return true; // book only
    const chapter = parseInt(m[2], 10);
    if (chapter < 1 || chapter > book.chapters) return false;
    if (!m[3]) return true; // book+chapter
    const verse = parseInt(m[3], 10);
    // For performance, just allow 1-150 verses per chapter (Psalms has 150 max)
    return verse >= 1 && verse <= 150;
  }).slice(0, 20);
}
